import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { GuiService } from 'src/app/services/gui.service';
import { RestService } from 'src/app/services/rest.service';

@Component({
  selector: 'vex-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss']
})
export class SupportComponent implements OnInit {
  message: string = '';
  terms: boolean = false;
  spinner: boolean = false;

  constructor(private dialogRef: MatDialogRef<any>, public translate: TranslateService, public guiService: GuiService, private restService: RestService) { }

  ngOnInit() {}

  closeModal() {
    this.dialogRef.close();
  }

  send(){
    this.spinner = true;
    this.restService.postService('help', '/support/email', {"message":this.message}).subscribe((ris)=>{
      this.terms = false;
      this.message = '';
      this.spinner = false;
    })
  }

}
